import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export const useVerifySignUpEmail = (token: string) => {
  return useQuery({
    queryKey: ["verify-sign-up-email", token],
    queryFn: async () => {
      const { data } = await axios.get(`provider_users/verify_email?confirmation_token=${token}`);
      return data;
    },
    retry: 0,
    enabled: !!token,
  });
};
